import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { resolveLocaleContext } from "../../../_utils/localeContext";
import "../Styles/MaintenanceNotice.css";

class MaintenanceNotice extends Component {
    getResolvedContext = () => {
        return resolveLocaleContext({
            search: this.props.location.search,
            store: this.props.store,
            language: this.props.language,
            country: this.props.country,
            storeList: null,
            countryList: this.props.country_list
        });
    };

    getViewQueryParameters() {
        const resolved = this.getResolvedContext();

        if (JSON.stringify(this.props.store) !== JSON.stringify(resolved.store)) {
            this.props.setStore(resolved.store);
        }

        if (this.props.language !== resolved.language) {
            this.props.setLanguage(resolved.language);
        }

        if (this.props.country !== resolved.country) {
            this.props.setCountry(resolved.country);
        }
    }

    getLocale() {
        return this.getResolvedContext().locale.MAINTENANCE_NOTICE;
    }

    componentDidMount() {
        this.getViewQueryParameters();
        this.postMessageToParentWindow();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            this.getViewQueryParameters();
        }

        this.postMessageToParentWindow();
    }

    postMessageToParentWindow() {
        let rootElement = document.getElementById("root");
        let height = Math.max(rootElement.scrollHeight, rootElement.offsetHeight, rootElement.clientHeight);

        let data = {
            action: "SITE_UPDATED",
            height
        };
        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    render() {
        const locale = this.getLocale();

        return (
            <main className="maintenance-notice" role="main" aria-labelledby="maintenance-notice-title">
                <section className="maintenance-notice__panel" aria-describedby="maintenance-notice-description">
                    <div className="maintenance-notice__status">
                        <span className="maintenance-notice__status-marker" aria-hidden="true" />
                        {locale.STATUS}
                    </div>

                    <h1 id="maintenance-notice-title">{locale.TITLE}</h1>

                    <p id="maintenance-notice-description">{locale.DESCRIPTION}</p>

                    <p>{locale.MESSAGE}</p>

                    {locale.EXPECTED_WINDOW && <div className="maintenance-notice__detail">{locale.EXPECTED_WINDOW}</div>}
                </section>
            </main>
        );
    }
}

export default withRouter(MaintenanceNotice);
